if (!customElements.get('media-gallery')) {
  customElements.define(
		'media-gallery',
		class MediaGallery extends HTMLElement {
			constructor() {
				super();
				this.elements = {
					liveRegion: this.querySelector('[id^="GalleryStatus"]'),
					viewer: this.querySelector('[id^="GalleryViewer"]'),
					thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
				};
				this.mql = window.matchMedia('(min-width: 750px)');
				if (!this.elements.thumbnails) return;

				this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
				this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
					mediaToSwitch
						.querySelector('button')
						.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
				});
				if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

				this.imageCaption = this.elements.viewer.querySelectorAll('.image-caption') || null;
				this.updateImageCaption();
				this.buttonForText = document.querySelector('.click-for-image-text');
				console.log('🚀 ~ MediaGallery ~ constructor ~ this.buttonForText:', this.buttonForText);
				this.buttonForText.addEventListener('click', this.onButtonClickedForText.bind(this));
			}

			updateImageCaption(dataIndex = 0) {
				if (this.imageCaption && this.imageCaption?.length > 0) {
					this.imageCaption.forEach((caption, index) => {
						if (index != dataIndex) {
							caption.style.height = '0';
							caption.style.opacity = '0';
							caption.style.display = 'none';
						} else {
              console.log('dataIndex', dataIndex);
							const hasTable = caption.querySelector('table') || caption.querySelector('ul');
							if (hasTable) {
                console.log('has table?')
								this.buttonForText.style.display = 'block';
                this.buttonForText.setAttribute('aria-controls', `caption-${dataIndex + 1}`);
								this.buttonForText.dataset.index = dataIndex + 1;

							} else {
								if (this.buttonForText) {
									this.buttonForText.style.display = 'none';
								}
								caption.style.height = '100%';
								caption.style.display = 'block';
								caption.style.opacity = '1';
							}
						}
					});
				}
			}

			onSlideChanged(event) {
				const thumbnail = this.elements.thumbnails.querySelector(
					`[data-target="${event.detail.currentElement.dataset.mediaId}"]`
				);
				this.setActiveThumbnail(thumbnail);
				const dataIndex = event.detail.currentPage - 1;
        console.log('update image caption');
				this.updateImageCaption(dataIndex);
			}

			onButtonClickedForText(event) {
        const index = event.srcElement.dataset.index;
        const currCaption = Array.prototype.slice.call(this.imageCaption).filter(caption => caption.dataset.index == index)[0];
        if (event.srcElement.hasAttribute('open')) {
          currCaption.classList.remove('show-caption');
          currCaption.classList.add('show-caption');
          currCaption.style.height = '0';
          currCaption.style.opacity = '0';
          currCaption.style.display = 'none';
          event.srcElement.innerText = 'Click for Image Text';
          this.buttonForText.removeAttribute('open');
					this.buttonForText.setAttribute('aria-expanded', false);
        } else {
					currCaption.id = `caption-${currCaption.dataset.index};`
          currCaption.classList.add('show-caption');
					currCaption.style.height = 'auto';
					currCaption.style.display = 'block';
					currCaption.style.opacity = '1';
					event.srcElement.innerText = 'Click to Close';
					this.buttonForText.setAttribute('open', '');
					this.buttonForText.setAttribute('aria-expanded', true);
        }

			}

			setActiveMedia(mediaId) {
				const activeMedia =
					this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
					this.elements.viewer.querySelector('[data-media-id]');
				if (!activeMedia) {
					return;
				}
				this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
					element.classList.remove('is-active');
					element.setAttribute('tabindex', -1);
				});
				this.elements.viewer.querySelectorAll('li[data-media-id]').forEach((element) => {
					element.setAttribute('aria-hidden', true);
				});
				activeMedia?.classList?.add('is-active');
				activeMedia.setAttribute('aria-hidden', false);
				activeMedia.removeAttribute('tabindex');
				const button = activeMedia.querySelector('button') || null;
				if (button) {
					button.removeAttribute('tabindex');
					activeMedia.setAttribute('aria-hidden', false);
				}
				const dataIndex = activeMedia.dataset.index - 1;
				console.log("🚀 ~ MediaGallery ~ setActiveMedia ~ dataIndex:", dataIndex);
				this.updateImageCaption(dataIndex);

				this.preventStickyHeader();
				window.setTimeout(() => {
					if (!this.mql.matches || this.elements.thumbnails) {
						activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
					}
					const activeMediaRect = activeMedia.getBoundingClientRect();
					// Don't scroll if the image is already in view
					if (activeMediaRect.top > -0.5) return;
					const top = activeMediaRect.top + window.scrollY;
					window.scrollTo({ top: top, behavior: 'smooth' });
				});
				this.playActiveMedia(activeMedia);

				if (!this.elements.thumbnails) return;
				const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
				this.setActiveThumbnail(activeThumbnail);
				this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
			}

			setActiveThumbnail(thumbnail) {
				if (!this.elements.thumbnails || !thumbnail) return;

				this.elements.thumbnails
					.querySelectorAll('button')
					.forEach((element) => element.removeAttribute('aria-current'));
				thumbnail.querySelector('button').setAttribute('aria-current', true);
				if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

				this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
			}

			announceLiveRegion(activeItem, position) {
				const image = activeItem.querySelector('.product__modal-opener--image img');
				if (!image) return;
				image.onload = () => {
					this.elements.liveRegion.setAttribute('aria-hidden', false);
					this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
					setTimeout(() => {
						this.elements.liveRegion.setAttribute('aria-hidden', true);
					}, 2000);
				};
				image.src = image.src;
			}

			playActiveMedia(activeItem) {
				window.pauseAllMedia();
				const deferredMedia = activeItem.querySelector('.deferred-media');
				if (deferredMedia) deferredMedia.loadContent(false);
			}

			preventStickyHeader() {
				this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
				if (!this.stickyHeader) return;
				this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
			}

			removeListSemantic() {
				if (!this.elements.viewer.slider) return;
				this.elements.viewer.slider.setAttribute('role', 'presentation');
				this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
			}
		}
	);
}
